import React from 'react';
import { FormGroup } from 'reactstrap';
import { FlexStartRow, FormLabel } from '../common/forms/FormElements';
import { CountyLabel } from '../uscounties/CountyLabel';
import JobFileAttachments from '../job/JobFileAttachments';
import ArcGisLocationDisplay from '../lowboyDispatch/ArcGisLocationDisplay';

export class AssignmentLocationDisplay extends React.Component {
    getDtoToEncodedLocation = (locationDto) => {
        let locationString = '' + locationDto.adddress1;

        if (locationDto.adddress2) {
            locationString += ` ${locationDto.adddress2}`;
        }

        locationString += `${locationDto.city}, ${locationDto.state} ${locationDto.zip} ${locationDto.countryCode}`;

        return encodeURIComponent(locationString);
    };

    getEncodedLocation = () => {
        const { assignment } = this.props;

        if (!assignment) {
            return null;
        }

        if (assignment.meetingLocation) {
            return this.getDtoToEncodedLocation(assignment.meetingLocation);
        }

        if (assignment.jobLocation) {
            return this.getDtoToEncodedLocation(assignment.jobLocation);
        }

        return null;
    };

    render() {
        const {
            loading,
            assignment,
            jobUploadsEnabled,
            arcGisLocation,
            makeLink,
        } = this.props;

        if (loading) {
            return null;
        }

        if (arcGisLocation) {
            return (
                <ArcGisLocationDisplay
                    arcGisLocation={arcGisLocation}
                    makeLink={makeLink}
                />
            );
        }

        const encodedLocation = this.getEncodedLocation();

        return (
            <div className="locationDetails">
                <FormGroup>
                    <FormLabel
                        htmlFor="meetingLocation"
                        text="Meeting Location"
                        className="bottom-border"
                    />
                    <FlexStartRow>
                        {!!(assignment ?? {}).meetingLocationUrlFormatted && (
                            <a
                                rel="noopener noreferrer"
                                className="text-white mr-2 btn btn-sm btn-success p-1"
                                title="Open in Google Maps"
                                href={`https://maps.google.com?q=${assignment.meetingLocationUrlFormatted}`}
                                target="_blank"
                            >
                                <i className="fa fa-map-marked-alt" />
                            </a>
                        )}
                        <span id="meetingLocation" name="meetingLocation">
                            {assignment.meetingLocation ?? '-'}
                        </span>
                    </FlexStartRow>
                </FormGroup>
                <FormGroup>
                    <FormLabel
                        htmlFor="jobLocation"
                        text="Job Location"
                        className="bottom-border"
                    />
                    <FlexStartRow>
                        {!!(assignment ?? {}).jobLocationUrlFormatted && (
                            <a
                                rel="noopener noreferrer"
                                className="text-white mr-2 btn btn-sm btn-success p-1"
                                title="Open in Google Maps"
                                href={`https://maps.google.com?q=${assignment.jobLocationUrlFormatted}`}
                                target="_blank"
                            >
                                <i className="fa fa-map-marked-alt" />
                            </a>
                        )}

                        {makeLink && (
                            <a
                                rel="noopener noreferrer"
                                className="text-white mr-2 btn btn-sm btn-success p-2"
                                title="Open in Google Maps"
                                href={`https://www.google.com/maps/place/${encodedLocation}`}
                                target="_blank"
                            >
                                <i className="fa fa-map-marked-alt" />
                            </a>
                        )}
                        <span id="jobLocation" name="jobLocation">
                            {assignment.jobLocation ?? '-'}
                        </span>
                    </FlexStartRow>
                </FormGroup>

                {Boolean(assignment?.usCounty) && (
                    <FormGroup>
                        <FormLabel
                            htmlFor="usCounty"
                            text="County"
                            className="bottom-border"
                        />
                        <FlexStartRow>
                            <div>
                                <CountyLabel {...assignment.usCounty} />
                            </div>
                        </FlexStartRow>
                    </FormGroup>
                )}

                {!!jobUploadsEnabled &&
                    !!(assignment.jobUploads ?? []).length && (
                        <FormGroup className="mt-2">
                            <FormLabel
                                style={{
                                    fontSize: '14px',
                                }}
                                text="File Attachments"
                                className="bottom-border"
                            />
                            <FlexStartRow className="pl-3">
                                <JobFileAttachments
                                    viewOnly
                                    className="d-flex flex-row align-items-center flex-wrap"
                                    job={{
                                        id: assignment.jobId,
                                        uploads: assignment.jobUploads,
                                    }}
                                />
                            </FlexStartRow>
                        </FormGroup>
                    )}
            </div>
        );
    }
}
